import React from "react";
import { Layout } from "src/components/layout/Layout";
import { ModuleRouter } from "src/components/molecules";
import { OthersRoute } from "./others.routes";

export function Others() {
  return (
    <Layout>
      {OthersRoute.subRoutes && (
        <ModuleRouter subRoutes={OthersRoute.subRoutes} path={OthersRoute.path} />
      )}
    </Layout>
  );
}
